import download from './download/index.vue'
import pagination from './pagination/index.vue'
import upload from './upload/index.vue'
import table from './table/index.vue'
import qrcode from './qrcode/index.vue'
import xls from './xls/index.vue'
export default {
  install(Vue: any) {
    Vue.component('Download', download)
    Vue.component('Pagination', pagination)
    Vue.component('Upload', upload)
    Vue.component('Table', table)
    Vue.component('Qrcode', qrcode)
    Vue.component('Xls', xls)
  }
}
